// extracted by mini-css-extract-plugin
module.exports = {"container":"AspectRatio_container__24W5D","expandOnFullScreen":"AspectRatio_expandOnFullScreen__1ei-k"};